/** language code with or without region, returns undefined if str is not a valid BCP 47 code */
export const checkLanguageCode = (str: string) =>
  /^[a-z]{1,8}(-[a-zA-Z0-9]{1,8})*$/u.exec(str)?.[0];
